import { ActivityCodeFormData } from "@/formTypes/ActivityCodeFormDataType";
import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiSchema, NotFoundError } from "./ApiClient";
import { getTenantId } from "@utils/Auth";

export type ActivityCodeDataType = Partial<ApiSchema["ActivityCode"]["type"] & ActivityCodeFormData>;

class Api extends GenericModelApi<"ActivityCode", ActivityCodeDataType> {

    async getDefaultActivityCode(): Promise<ActivityCodeDataType> {
        const tenantId = await getTenantId();
        const filterObject = {
            and: [
                { owner: { eq: tenantId } },
                { default: { eq: true } },
            ]
        };

        const { data, errors } = await ApiClient.models[this.modelName].list({
            filter: filterObject,
        });

        if (errors) {
            throw new NotFoundError(`Error al obtener la activdad economica por defecto`, "API_ERROR", errors);
        }
        if (data.length > 0) {
            return data[0]
        }

        return {};
    }

}

export const ActivityCodeApi = new Api("ActivityCode", "title")